import { render, staticRenderFns } from "./CdekInfo.vue?vue&type=template&id=18ed429a&"
import script from "./CdekInfo.vue?vue&type=script&lang=js&"
export * from "./CdekInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports